export const MIN_VALUE = 0;
export const MAX_VALUE = 100000000;
